import { mergeRecord } from './mergeRecord';

type UpdateRecord = <T, R extends Partial<T>>(record: Record<string, T>, id: string, newValues: R) => Record<string, T>;
export const updateRecord: UpdateRecord = (record, id, newValues) => {
  if (!record[id]) {
    return record;
  }

  return mergeRecord(record, id, newValues);
};
